import {
  Box,
  Button,
  Center,
  Flex,
  Image,
  Text,
  useToast,
} from '@chakra-ui/react'
import Logo from '@assets/svgs/roadmap/logo.svg'
import MicIcon from '@assets/svgs/roadmap/mic.svg'
import {CommonColors} from '@utils/CommonStyles'
import Background from '@assets/images/background-lo-trinh.png'
import GuideImage from '@assets/images/guide_open_browser.png'

const InAppBrowser = () => {
  const toast = useToast()

  const handleCopyLink = async () => {
    try {
      // Thử sử dụng Clipboard API trước
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(window.location.href)
      } else {
        // Fallback cho mobile: tạo textarea tạm thời
        const textArea = document.createElement('textarea')
        textArea.value = window.location.href
        textArea.style.position = 'fixed'
        textArea.style.left = '0'
        textArea.style.top = '0'
        textArea.style.opacity = '0'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()

        try {
          document.execCommand('copy')
          textArea.remove()
        } catch (err) {
          console.error('Không thể copy:', err)
          toast({
            title: 'Không thể copy URL',
            status: 'error',
            duration: 2000,
            isClosable: true,
          })
          return
        }
      }

      toast({
        title: 'URL đã được copy',
        status: 'success',
        duration: 2000,
        isClosable: true,
      })
    } catch (err) {
      console.error('Lỗi copy:', err)
      toast({
        title: 'Không thể copy URL',
        status: 'error',
        duration: 2000,
        isClosable: true,
      })
    }
  }

  return (
    <Flex
      h={'100vh'}
      p={'16px'}
      flexDirection={'column'}
      maxW={'500px'}
      mx={'auto'}>
      <Center p={'16px'} pt={0} borderBottom={'1px solid #E0E0E0'}>
        <Flex w={'fit-content'} alignItems="center" cursor="pointer">
          <Image src={MicIcon} alt="IELTS Coach Logo" mr={2} />
          <Image src={Logo} alt="IELTS Coach Logo" />
        </Flex>
      </Center>
      <Box pt={'24px'}>
        <Center flexDirection={'column'}>
          <Text fontSize="20px" fontWeight="bold">
            Làm sao để sử dụng?
          </Text>
          <Text mt={'8px'} fontWeight={500}>
            Để trải nghiệm tốt nhất bạn hãy thử các cách sau.
          </Text>
        </Center>
        <Flex flexDirection={'column'} mt={'16px'}>
          <Flex flexDirection={'column'}>
            <Text fontSize="18px" fontWeight="bold" mr={2}>
              Cách 1:
            </Text>
            <Text fontSize="16px">
              Ấn vào Dấu ba chấm ở góc phải màn hình, chọn 'Mở bằng trình duyệt
              bên ngoài'
            </Text>
          </Flex>
          <Image
            src={GuideImage}
            alt="Guide Image"
            w={'100%'}
            objectFit={'cover'}
            mt={'16px'}
          />
          <Text mt={'16px'}>Hoặc</Text>
          <Flex flexDirection={'column'} mt={'8px'}>
            <Text fontSize="18px" fontWeight="bold" mr={2}>
              Cách 2:
            </Text>
            <Flex flexDirection={'column'} mt={'8px'}>
              <Flex flexDirection={'column'}>
                <Text fontSize="14px" fontWeight="bold" mr={2}>
                  Bước 1:
                </Text>
                <Text fontSize="16px">
                  Ra màn hình chính. Mở trình duyệt bất kỳ (chrome, safari...).
                </Text>
              </Flex>
              <Flex flexDirection={'column'} mt={'8px'}>
                <Text fontSize="14px" fontWeight="bold" mr={2}>
                  Bước 2:
                </Text>
                <Text fontSize="16px">
                  Nhập{' '}
                  <Text
                    as="span"
                    color={CommonColors.primary}
                    cursor={'pointer'}
                    onClick={handleCopyLink}>
                    coachielts.giasu.ai
                  </Text>{' '}
                  vào thanh tìm kiếm và sử dụng.
                </Text>
              </Flex>
            </Flex>
          </Flex>
          <Button mt={'16px'} w={'fit-content'} onClick={handleCopyLink}>
            Copy link
          </Button>
          <Box mt={'16px'}>
            <Image
              src={Background}
              alt="Background"
              w={'100%'}
              objectFit={'cover'}
            />
          </Box>
        </Flex>
      </Box>
    </Flex>
  )
}

export default InAppBrowser
